module.exports = __webpack_public_path__ + "static/media/Ecofric_Logo_Svart.eed77631.zip";